// Haptics — Lightweight haptic feedback utility
// Uses the Web Vibration API on supported devices, gracefully degrades

const isSupported = typeof navigator !== 'undefined' && 'vibrate' in navigator;

export type HapticType = 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error' | 'selection';

const HAPTIC_PATTERNS: Record<HapticType, number | number[]> = {
  light:     10,
  medium:    20,
  heavy:     30,
  success:   [10, 50, 10],
  warning:   [20, 30, 20],
  error:     [30, 50, 30, 50, 30],
  selection: 5,
};

export function haptic(type: HapticType = 'light') {
  if (!isSupported) return;
  try {
    navigator.vibrate(HAPTIC_PATTERNS[type]);
  } catch {
    // ignore
  }
}

export const HapticClass = ({ type = 'light', onClick, className = '', children, testId }: { type?: HapticType; onClick?: () => void; className?: string; children: React.ReactNode; testId?: string }) => {
  return (
    <button
      onClick={() => { haptic(type); onClick?.(); }}
      data-testid={testId}
      className={className}
    >
      {children}
    </button>
  );
};
